import { memo } from "react";
import { useTranslation } from "react-i18next";
import { SlideshowTitleCard } from "@wedding/slideshow-ui";
import { QrCode } from "./qr-code";
import { cdnUrl } from "../../lib/cdn";

interface IdleScreenProps {
  title: string;
  dateLine: string | null;
  url: string;
  coverUrl: string | null;
}

/**
 * Guest attract / interstitial screen — now a thin wrapper over the shared
 * SlideshowTitleCard (identical to the Reji monitor card), adding the guest-only
 * QR + hint slot underneath.
 */
function IdleScreenImpl({ title, dateLine, url, coverUrl }: IdleScreenProps) {
  const { t } = useTranslation();
  return (
    <SlideshowTitleCard
      title={title}
      dateLine={dateLine}
      coverUrl={coverUrl ? cdnUrl(coverUrl, { w: 64 }) : null}
      qrSlot={
        <div className="mt-4 flex flex-col items-center gap-4">
          <div className="rounded-2xl bg-white p-3 shadow-2xl">
            <QrCode value={url} size={184} />
          </div>
          <p className="text-white/80 text-base md:text-lg max-w-sm">{t("slideshow.idleHint")}</p>
        </div>
      }
    />
  );
}

export const IdleScreen = memo(IdleScreenImpl);
